import { StyleSheet, Text, useWindowDimensions, Image, View } from 'react-native'
import React, { useEffect } from 'react'
import Animated, {useAnimatedStyle, withSpring, useSharedValue} from 'react-native-reanimated'
import { colors } from '../../colors';
import { displayFont, bodyFont } from '../../fonts';
import { isMobile } from 'react-device-detect';


const Downloads = () => {
    const window = useWindowDimensions();
    const rightPost = useSharedValue(-window.width);
    const animatedStyles = useAnimatedStyle(() => {
        return {
            right: rightPost.value,
        };
    });

    const narrow = window.width < 768;
    const hoverInMenu = () => rightPost.value = withSpring(window.width * 0.8);

    useEffect(() => {
        hoverInMenu();
    }, []);

    useEffect(() => {
        hoverInMenu();
    }, [window.width]);
    

  return (
    <View style={styles.container}>
      {!isMobile && <Animated.View style={[styles.design, animatedStyles]}>
            <View style={[styles.triangle, {height: window.height * 2}]}></View>
        </Animated.View>}
        <View style={[styles.bodyContainer, {flexDirection: window.width > 768 ? 'row' : 'column'}]}>
            <View style={[styles.downloadContainer, narrow && styles.downloadContainerNarrow]}>
            <Image
              accessibilityLabel="iVYOOO on a phone"
              resizeMode="contain"
              style={[styles.logo, narrow && {width: Math.min(220, window.width - 48), height: 280}]}
              source={{uri: 'https://ivyooo.com/assets/images/phone.png'}}
            />
            <Text style={{color: colors.red, fontFamily: displayFont, fontWeight: '700', fontSize: narrow ? 32 : 48, letterSpacing: 1, padding: 0}}>iVYOOO</Text>
            <Text style={[styles.download, narrow && styles.downloadNarrow]}>COMING SOON</Text>
            {!isMobile && !narrow && <Text style={[styles.avail, {fontFamily: bodyFont, fontSize: 16, paddingTop: 8, textAlign: 'center', paddingHorizontal: 16}]}>Coming soon on your favorite browser</Text>}
            </View>
        </View>
    </View>
  )
}

export default Downloads

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: colors.background,
        height: '100%',
    },
    bottomModal: {
      position: 'absolute',
      height: '30%',
      width: '100%',
      backgroundColor: 'white',
      overflow: 'hidden',
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
    },  
    design: {
        flex: 1,
        backgroundColor: colors.red,
    },
    triangle: {
        backgroundColor: colors.red,
        flex: 1,
        transform: [
            {
                rotate: '45deg',
                translateY: -'50%',
            }
        ]
    },
    avail: {
        color: '#A1A1A1'
      },
      button: {
        backgroundColor: colors.red,
        borderRadius: 40,
        width: '80%',
        alignSelf: 'center',
        margin: 10,
      },
      video: {
        width: '100%',
        height: '100%',
        position: 'absolute',
      },
      downloadContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        paddingHorizontal: 24,
      },
      downloadContainerNarrow: {
        paddingTop: 24,
      },
      trailerContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      },
      phone: {
        height: '150%',
        width: '150%',
        right: '-50%',
        position: 'absolute',
        top: -100,
      },
      backdrop: {
        position: 'absolute',
        flex: 1,
        backgroundColor: 'black',
        opacity: 0.8,
        width: '100%',
        height: '100%',
      },
      availContainer: {
        flexDirection: 'column',
        padding: 4,
        marginLeft: 4,
        paddingHorizontal: 10,
      },
      bodyContainer: {
        flex: 1,
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute'
      },
      downloadBtn: {
        borderWidth: 1,
        borderColor: colors.red,
        backgroundColor: 'black',
        borderRadius: 4,
        padding: 8,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 20,
      },  
      download: {
        color: 'white',
        fontFamily: displayFont,
        textAlign: 'center',
        padding: 20,
        fontSize: 28,
        letterSpacing: 2,
      },
      downloadNarrow: {
        fontSize: 18,
        letterSpacing: 3,
        paddingTop: 8,
        paddingBottom: 0,
      },
      logo: {
        width: 500,
        height: 400
      },
      header: {
        width: '100%',
        height: 100,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingHorizontal: 20,
      },
      version: {
        color: colors.text,
        bottom: 0,
        width: '100%',
        backgroundColor: 'red',
        textAlign: 'center'
      },
      text : {textAlign: 'center', padding: 10, fontWeight: 'bold', marginBottom: 10, borderBottomWidth: 0.1, borderBottomColor: 'lightgrey'},
      appText : {textAlign: 'center', fontWeight: '600'},
      icons: {
        height: 40,
        width: 40,
        marginHorizontal: 10,
        borderWidth: 0.1,
        borderColor: 'lightgrey',
        borderRadius: 4,
      },
      comingSoon: {
        borderWidth: 1,
        borderColor: colors.red,
        backgroundColor: 'black',
        borderRadius: 4,
        paddingVertical: 14,
        paddingHorizontal: 24,
        margin: 20,
        minHeight: 44,
        justifyContent: 'center',
      },
      comingSoonText: {
        color: 'white',
        fontSize: 18,
        fontWeight: '600',
        textAlign: 'center',
      },
      openButton: {
        backgroundColor: colors.red,
        padding: 10,
        paddingHorizontal: 16,
        borderRadius: 40,
        marginRight: 10,
        minHeight: 44,
        minWidth: 120,
        justifyContent: 'center',
      },
      continueButton: {
        backgroundColor: colors.lightgrey,
        borderWidth: 0.1,
        borderColor: colors.offwhite,
        padding: 10,
        borderRadius: 40,
        marginRight: 10,
        minHeight: 44,
        minWidth: 100,
        justifyContent: 'center',
      }
})